import React from 'react';
import { OptionProps, components } from 'react-select';
import { GenericDropdownOption } from '../../../utils/utils.types';
import { ApexCampaign } from '@round/api';
import useNonNullContext from '../../../hooks/useNonNullContext';
import { OptionsContext } from '../../../contexts/OptionsContext';
import capitalize from 'lodash/capitalize';
import styles from './CampaignOption.module.css';

export type CampaignOption = GenericDropdownOption<number> &
    Pick<ApexCampaign, 'type' | 'currency' | 'client_name' | 'client_user_email'>;

type CampaignSelectOptionProps = OptionProps<CampaignOption, false>;

const CampaignSelectOption = (props: CampaignSelectOptionProps) => {
    const { currencies } = useNonNullContext(OptionsContext);
    const values = props.data as CampaignOption;
    return (
        <components.Option {...props}>
            <div>
                <p className={styles.label}>{props.label}</p>
                <div className={styles.infoContainer}>
                    <div className={styles.infoGroup}>
                        <span className={styles.bold}>{values?.client_name}</span>
                        <span>{values?.client_user_email}</span>
                    </div>

                    <div className={styles.infoGroup}>
                        <span>Campaign Type:</span>
                        <span className={styles.bold}>{capitalize(values?.type)}</span>
                    </div>

                    <div className={styles.infoGroup}>
                        <span>Currency:</span>
                        <span className={styles.bold}>{currencies.find((c) => c.id === values?.currency)?.name}</span>
                    </div>
                </div>
            </div>
        </components.Option>
    );
};

export default CampaignSelectOption;
